import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    height: "40vh",
    backgroundSize: "cover",
    position: "relative",
    //borderRadius: "10px",
  },
  caption: {
    position: "absolute",
    bottom: 0,
    left: 0,
    padding: "10px",
    background: "#33333399",
    //borderRadius: "0 0 10px 10px",
  },
  title: {
    color: "#109e92",
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  description: {
    color: "#acd2cf",
  },
});

export default function CarouselItem({ item }) {
  const { description, img } = item;
  const classes = useStyles();
  return (
    <div
      className={classes.root}
      style={{ backgroundImage: "url(" + img + ")" }}
    >
      <Grid
        container
        className={classes.caption}
        direction="column"
        justify="flex-end"
        alignItems="flex-start"
      >
        {/* <Typography variant="h3" component="h2" className={classes.title}>
          {name}
        </Typography> */}
        <Typography variant="h6" component="p" className={classes.description}>
          {description}
        </Typography>
      </Grid>
    </div>
  );
}
